import apiV2 from '../api/v2';
import type { HistoryBucket } from './dmMonitoringOverviewHistory';
import type { VirtualAppointmentStatus, VirtualAppointmentTeam } from './virtualAppointments';

export interface VaFlowPerson {
    // 'unknown' when the VA was marked done by nobody we can name.
    userId: string;
    name: string;
}

export interface VaFlowBucket {
    // YYYY-MM-DD in the requested time zone.
    bucketStart: string;
    due: number;
    treated: number;
    treatedBy: Record<string, number>;
}

export interface VaFlowResponse {
    bucket: HistoryBucket;
    // Window treated desc.
    people: VaFlowPerson[];
    // Zero-filled, oldest first.
    series: VaFlowBucket[];
}

export interface VaMixType {
    // 'custom' groups every custom type.
    key: string;
    label: string;
    total: number;
    counts: Record<VirtualAppointmentStatus, number>;
}

export interface VaMixResponse {
    statuses: VirtualAppointmentStatus[];
    // Total desc.
    types: VaMixType[];
}

export type VaMixTeam = 'all' | VirtualAppointmentTeam;

export const fetchVaMix = async (team: VaMixTeam): Promise<VaMixResponse> => {
    const response = await apiV2.get<{ success: boolean; data: VaMixResponse }>(
        '/admin/monitoring/overview/virtual-appointments/mix',
        { params: team === 'all' ? {} : { team } }
    );
    return response.data.data;
};
